<agr-dialog (confirm)="save()" (alt)="alt()" (cancel)="cancel()" [data]="data">
  <div class="spacing--margin-horizontal spacing--margin-top">
    <form [formGroup]="formGroup">
      <div class="spacing--margin-bottom extended-baseline-settings">
        <span class="text--small text--h5 label">
          {{ 'feed-profit.detail.quick-simulation-item.title' | translate }}
        </span>
        <div class="flex--column spacing--margin-top">
          <mat-form-field class="flex__child--auto">
            <mat-label>{{
              'feed-profit.settings.extended-baseline-settings.startWeight' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.01"
              placeholder="{{
                'feed-profit.settings.extended-baseline-settings.startWeight' | translate
              }}"
              data-test="quicksimulations-settings__startWeight"
              formControlName="startWeight"
            />
            <mat-error *ngIf="formGroup.controls.startWeight.invalid">
              {{
                'feed-profit.settings.extended-baseline-settings.error-startweight' | translate
              }}</mat-error
            >
          </mat-form-field>
          <mat-form-field class="flex__child--auto">
            <span matTextPrefix class="spacing--padding-half-right">{{ currencySymbol }}</span>
            <mat-label>{{
              'feed-profit.settings.extended-baseline-settings.pigletPrice' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.01"
              placeholder="{{
                'feed-profit.settings.extended-baseline-settings.pigletPrice' | translate
              }}"
              data-test="quicksimulations-settings__pigletPrice"
              formControlName="pigletPrice"
            />
            <mat-error *ngIf="formGroup.controls.pigletPrice.invalid">
              {{
                'feed-profit.settings.extended-baseline-settings.error-pigletprice' | translate
              }}</mat-error
            >
          </mat-form-field>
          <mat-form-field class="flex__child--auto">
            <mat-label>{{
              'feed-profit.settings.extended-baseline-settings.slaughteredWeightInKg' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.01"
              placeholder="{{
                'feed-profit.settings.extended-baseline-settings.slaughteredWeightInKg' | translate
              }}"
              data-test="quicksimulations-settings__slaughteredWeightInKg"
              formControlName="slaughteredWeightInKg"
            />
            <mat-error *ngIf="formGroup.controls.slaughteredWeightInKg.invalid">
              {{
                'feed-profit.settings.extended-baseline-settings.error-slaughteredweightinkg'
                  | translate
              }}</mat-error
            >
          </mat-form-field>
          <mat-form-field class="flex__child--auto">
            <span matTextPrefix class="spacing--padding-half-right">{{ currencySymbol }}</span>
            <mat-label>{{
              'feed-profit.settings.extended-baseline-settings.revenuePerKg' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.01"
              placeholder="{{
                'feed-profit.settings.extended-baseline-settings.revenuePerKg' | translate
              }}"
              data-test="quicksimulations-settings__revenuePerKg"
              formControlName="revenuePerKg"
            />
            <mat-error *ngIf="formGroup.controls.revenuePerKg.invalid">
              {{
                'feed-profit.settings.extended-baseline-settings.error-revenueperkg' | translate
              }}</mat-error
            >
          </mat-form-field>
          <mat-form-field class="flex__child--auto">
            <span matTextPrefix class="spacing--padding-half-right">{{ currencySymbol }}</span>
            <mat-label>{{
              'feed-profit.settings.extended-baseline-settings.feedPackagePrice' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.01"
              placeholder="{{
                'feed-profit.settings.extended-baseline-settings.feedPackagePrice' | translate
              }}"
              data-test="quicksimulations-settings__feedPackagePrice"
              formControlName="feedPackagePrice"
            />
            <mat-error *ngIf="formGroup.controls.feedPackagePrice.invalid">
              {{
                'feed-profit.settings.extended-baseline-settings.error-feedpackageprice' | translate
              }}</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</agr-dialog>
